module.exports = __webpack_public_path__ + "img/promise.0fcbd363.png";